import React, { useState } from "react";
import { Link } from "react-scroll";

const Navbar = () => {
  const [scroll, setScroll] = useState(false);
  const onChangeHandler = () => {
    if (window.scrollY > 100) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  window.addEventListener("scroll", onChangeHandler);
  return (
    <div
      className={
        !scroll
          ? "py-3 flex bg-gradient-to-r bg-transparent flex-wrap justify-around items-center"
          : "py-3 flex bg-gradient-to-r from-cyan-500 to-blue-500 flex-wrap justify-around items-center"
      }
    >
      <div className="logo prose">
        <h3 className="cursor-pointer text-gray-200 uppercase font-bold">
          Fadillah Portfolio
        </h3>
      </div>
      <div className="nav-list prose ">
        <ul className="flex  gap-8">
          <li className="list-none cursor-pointer font-bold ">
            <a
              className="text-gray-200"
              style={{ textDecoration: "none" }}
              href="#about"
            >
              <Link
                activeClass="active"
                to="about"
                className="text-gray-200 decoration-transparent"
                spy={true}
                smooth={true}
                duration={500}
                offset={-10}
              >
                About
              </Link>
            </a>
          </li>
          <li className="list-none cursor-pointer font-bold">
            <Link
              activeClass="active"
              to="skills"
              className=" text-gray-200 decoration-transparent"
              spy={true}
              smooth={true}
              duration={500}
              offset={-10}
            >
              Skills
            </Link>
          </li>
          <li className="list-none cursor-pointer font-bold ">
            <Link
              activeClass="active"
              to="medsos"
              className="text-gray-200 decoration-transparent"
              spy={true}
              smooth={true}
              duration={500}
              offset={-10}
            >
              Media Social
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
